import { render, staticRenderFns } from "./CartUpsellItemCard.vue?vue&type=template&id=7827771c"
import script from "./CartUpsellItemCard.vue?vue&type=script&lang=ts"
export * from "./CartUpsellItemCard.vue?vue&type=script&lang=ts"
import style0 from "./CartUpsellItemCard.vue?vue&type=style&index=0&id=7827771c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports